import styled from '@emotion/styled'

import { CB } from 'theme/theme'

const ContentBox = styled.div`
  ${CB}
`

export default ContentBox
